class CartRemoveButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();
    const productId = this.getAttribute("data-product-id");
    const cartItems = this.closest("cart-items");

    if (this.classList.contains("multi-remove")) {
      cartItems.removeLinkedAddOnProducts(productId);
    } else {
      cartItems.updateQuantity(this.dataset.index, 0);
    }
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  isAddingProduct = false;

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
    this.checkCartItems();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  checkCartItems(event) {
    const cartItems = document.querySelectorAll(".cart-item");
    const uniqueCartItems = new Set();

    cartItems.forEach((cartItem) => {
      let linkedAddonId;
      let productAddonId;

      const linkedAddonIdElement = cartItem.querySelector(
        '.cart-properties dd.h6[data-product-property="data-linked-addon_id"]'
      );
      const productAddonIdElement = cartItem.querySelector(
        '.cart-properties dd.h6[data-product-property="data-product-addon_id"]'
      );

      if (linkedAddonIdElement) {
        linkedAddonId = linkedAddonIdElement.textContent.trim();
      }
      if (productAddonIdElement) {
        productAddonId = productAddonIdElement.textContent.trim();
      }

      if (linkedAddonId !== undefined && productAddonId !== undefined) {
        uniqueCartItems.add(linkedAddonId + " - " + productAddonId);
      }
    });

    uniqueCartItems.forEach((checkCart) => {
      let totalMatches = 0;

      cartItems.forEach((cartItem) => {
        const addonItems = cartItem.querySelectorAll(".addon_product_each");

        addonItems.forEach((addonItem) => {
          const addonLinkedAddonIdElement = addonItem.querySelector(
            'input[name="linked-addon-id"]'
          );
          const addonProductIdElement = addonItem.querySelector(
            'input[name="addonid"]'
          );
          const checkboxText = addonItem.querySelector(".addon_checkbox_text");

          const addonLinkedAddonId = addonLinkedAddonIdElement.value.trim();
          const addonProductId = addonProductIdElement.value.trim();
          const checkProduct = addonLinkedAddonId + " - " + addonProductId;

          if (checkCart === checkProduct) {
            totalMatches++;
            const matchedAddonItem = addonItem.querySelector(
              ".addon_checkbox_input"
            );
            if (matchedAddonItem) {
              matchedAddonItem.classList.add("ticked-checkbox");
              const updatedText = `<b>Added!</b> ${checkboxText.textContent.slice(
                4
              )}`;
              checkboxText.innerHTML = updatedText;
            } else {
            }
          }
        });
      });
    });
  }

  onChange(event) {
    const { target } = event;
    if (event.target.matches('input[type="checkbox"]')) {
      const id = event.target
        .closest(".addon_product_each")
        .querySelector('input[name="addonid"]');
      const type = event.target
        .closest(".addon_product_each")
        .querySelector("[data-product-addon]");
      const linkedId = event.target
        .closest(".addon_product_each")
        .querySelector('input[name="linked-addon-id"]');
      const productId = id.value;
      const addonValue = type.dataset.productAddon || null;
      const linkedAddonId = linkedId.value;
      const product = {
        id: productId,
        type: addonValue,
        linkedId: linkedAddonId,
      };

      const isTicked = event.target.classList.contains("ticked-checkbox");
      let isCheckboxAction = false;

      if (isTicked) {
        this.removeProductFromCart(product, true);
        isCheckboxAction = true;
      } else {
        this.addProductToCart(product, false);
        isCheckboxAction = true;
      }
    } else {
      this.updateQuantity(
        target.dataset.index,
        target.value,
        document.activeElement.getAttribute("name"),
        target.dataset.quantityVariantId
      );
    }
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "pricing-section",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".pricing-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  removeLinkedAddOnProducts(productId) {
    const cartItems = document.querySelectorAll(".cart-item");
    const products = [];

    cartItems.forEach((cartItem) => {
      const linkedAddonIdElement = cartItem.querySelector(
        '.cart-properties [data-product-property="data-linked-addon_id"]'
      );
      const productAddonIdElement = cartItem.querySelector(
        '.cart-properties [data-product-property="data-product-addon_id"]'
      );

      if (linkedAddonIdElement && productAddonIdElement) {
        const linkedAddonId = linkedAddonIdElement.textContent.trim();
        const productAddonId = productAddonIdElement.textContent.trim();

        if (linkedAddonId === productId) {
          const addonProduct = {
            id: productAddonId,
          };
          products.push(addonProduct);
        }
      }
    });

    const primaryProduct = {
      id: productId,
    };
    products.push(primaryProduct);
    this.removeMultiProducts(products);
  }

  removeMultiProducts(primaryProducts) {
    document.getElementById("cart-loading-spinner").style.display = "flex";
    let updates = {};

    primaryProducts.forEach((item) => {
      updates[item.id] = 0;
    });

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
        document.getElementById("cart-loading-spinner").style.display = "none";
      })
      .catch((error) => {
        document.getElementById("cart-loading-spinner").style.display = "none";
        console.error("Error:", error);
      });
  }

  updateQuantity(line, quantity, name, variantId, isCheckboxAction = false) {
    document.getElementById("cart-loading-spinner").style.display = "flex";

    this.enableLoading(line);

    try {
      const cartItem = document.querySelector(`#CartItem-${line}`)

      if (cartItem) {
        const { productId, variantId, preorderType } = cartItem.dataset;
        const quantityElement = cartItem.querySelector('input[data-default-value]')

        if (quantityElement) {
          const defaultQuantity = quantityElement.getAttribute('data-default-value')

          if (defaultQuantity && productId && variantId && preorderType) {
            if (window?.Globo?.Preorder && window?.GloboPreorderParams?.products) {
              let product = window.GloboPreorderParams.products.find(product => product.id.toString() == productId)

              if (product) {
                let profile = window.Globo.Preorder.getProductProfile(product, variantId, null)
                let quantityToEnd = profile?.quantity?.quantityToEnd;
                let moreQuantity = parseInt(quantity) - parseInt(defaultQuantity)

                if (profile?.isPreorder) {
                  if (preorderType == 'preorder' && quantityToEnd && parseInt(moreQuantity) > 0 && parseInt(moreQuantity) > parseInt(quantityToEnd)) {
                    let totalQuantity = parseInt(defaultQuantity) + parseInt(quantityToEnd)
                    alert(`There are still ${quantityToEnd} pre-order items that can be added to the cart. You can purchase up to ${totalQuantity} products`)
                    quantity = totalQuantity;
                    quantityElement.setAttribute('data-default-value', totalQuantity)
                  } else if (preorderType == 'normal' && parseInt(moreQuantity) > 0) {
                    alert(`The number of products instock has reached the limit`)
                    quantity = defaultQuantity;
                    quantityElement.setAttribute('data-default-value', defaultQuantity)
                  }
                } else {
                  if (preorderType == 'preorder' && parseInt(moreQuantity) > 0) {
                    alert(`The number of products instock has reached the limit`)
                    quantity = defaultQuantity;
                    quantityElement.setAttribute('data-default-value', defaultQuantity)
                  }
                }
              }
            }
          }
        }

      }
    } catch (error) {
      console.log('error: ', error)
    }


    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        document.dispatchEvent(new CustomEvent("globo.preorder.update.cart", {
          detail: {}
        }))
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors && !isCheckboxAction) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });

        const leftContainer = document.querySelector(".css-yv2z0c");
        const rightContainer = document.querySelector(".main_cart_footer");

        if (leftContainer && leftContainer.classList.contains("is-empty")) {
          rightContainer.style.display = "none";
        } else {
          rightContainer.style.display = "block";
        }

        window.location.reload();
        document.getElementById("cart-loading-spinner").style.display = "none";
      })
      .catch(() => {
        document.getElementById("cart-loading-spinner").style.display = "none";

        const cartItemErrorContainer =
          document.querySelector(".cart-item__error");
        const cartErrorContainer = document.querySelector(".cart_error");
        const cartItemErrorText = document
          .querySelector(".cart-item__error-text")
          .textContent.trim();
        const cartErrorsElement = document.getElementById("cart-errors");
        const cartErrorsText = cartErrorsElement.textContent.trim();

        if (cartItemErrorText.length != 0) {
          cartItemErrorContainer.style.display = "flex";
        } else {
          cartItemErrorContainer.style.display = "none";
        }

        if (cartErrorsText.length != 0) {
          cartErrorContainer.style.display = "flex";
        } else {
          cartErrorContainer.style.display = "none";
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errorTextElement = lineItemError.querySelector(
        ".cart-item__error-text"
      );
      if (errorTextElement.textContent.trim().length > 0) {
        lineItemError.style.display = "flex";
      } else {
        lineItemError.style.display = "none";
      }
    }

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    const cartItemErrorContainer = document.querySelector(".cart-item__error");
    const cartErrorContainer = document.querySelector(".cart_error");
    const cartItemErrorText = document
      .querySelector(".cart-item__error-text")
      .textContent.trim();
    const cartErrorsElement = document.getElementById("cart-errors");
    const cartErrorsText = cartErrorsElement.textContent.trim();

    if (cartItemErrorText.length != 0) {
      cartItemErrorContainer.style.display = "flex";
    } else {
      cartItemErrorContainer.style.display = "none";
    }

    if (cartErrorsText.length != 0) {
      cartErrorContainer.style.display = "flex";
    } else {
      cartErrorContainer.style.display = "none";
    }

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }

  addProductToCart(product, calledFromUpdateQuantity = false) {
    document.getElementById("cart-loading-spinner").style.display = "flex";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: product.id,
        quantity: 1,
        properties: {
          "data-product-addon_type": product.type,
          "data-product-addon_id": product.id,
          "data-linked-addon_id": product.linkedId,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.quantity !== 1) {
          this.updateQuantity(data.line, 1);
        }
        
        if (!calledFromUpdateQuantity) {
          window.location.reload();
        }
        document.getElementById("cart-loading-spinner").style.display = "none";
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
        document.getElementById("cart-loading-spinner").style.display = "none";
      });
  }

  removeProductFromCart(product, calledFromUpdateQuantity = false) {
    document.getElementById("cart-loading-spinner").style.display = "flex";
    return new Promise((resolve, reject) => {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: product.id,
          quantity: 0,
          properties: {
            "data-product-addon_type": product.type,
            "data-product-addon_id": product.id,
            "data-linked-addon_id": product.linkedId,
          },
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          resolve(data);
          window.location.reload();
          document.getElementById("cart-loading-spinner").style.display = "none";
        })
        .catch((error) => {
          document.getElementById("cart-loading-spinner").style.display = "none";
          reject(error);
        });
    });
  }

  removeExtraProductsFromCart(product, calledFromUpdateQuantity = false) {
    return new Promise((resolve, reject) => {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: product.id,
          quantity: 0,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}